// Module
var code = "<div class=\"grid grid-table layout-root\">\n  <div class=\"grid-item align-x-center align-y-center\">\n    <loader-container v-bind:animate=\"animate\"><slot></slot></loader-container>\n  </div>\n</div>\n";
// Exports
export default code;